<div class="flex-column flex-fill">
  <div class="row" style="padding-left: 12px;">
    <div class="col-md-3">
      <label class="project-scoping-capital-label">Total $</label>
      <input class="k-textbox form-control project-scoping-capital-textbox" [disabled]="true" value="{{estimateTotal}}" />
    </div>
    <div class="col-md-3">
      <label class="project-scoping-capital-label">$ per Well</label>
      <input class="k-textbox form-control project-scoping-capital-textbox" [disabled]="true" value="{{costPerWell}}" />
    </div>
    <div class="col-md-3">
      <label class="project-scoping-capital-label">$ per LL</label>
      <input class="k-textbox form-control project-scoping-capital-textbox" [disabled]="true" value="{{costPerLL}}" />
    </div>
    <div class="col-md-3">
      <label class="project-scoping-capital-label">$ per Cum 365 BO</label>
      <input class="k-textbox form-control project-scoping-capital-textbox" [disabled]="true" value="{{costPerCum365BO}}" />
    </div>
  </div>
</div>